import Dashboard from "../../../Pages/Public/Dashboard";
import Unauthorised from "../../../Pages/Public/Unauthorised";
import Login from "../../../Pages/Public/Login/Login";
import NoRights from "../../../Pages/Public/NoRights";
import OutOfService from "../../../Pages/Public/OutOfService/OutOfService";
import { LoginCallback } from "@okta/okta-react";
import { IRoute } from "./IbssRouter";

export default class PublicRoutes
{
    public routes: IRoute[] = [
        {
            isPublic: true,
            isAuthorised: () => true,
            path: "/norights",
            component: NoRights,
        },
        {
            isPublic: true,
            isAuthorised: () => true,
            path: "/out-of-service",
            component: OutOfService,
        },
        {
            isPublic: true,
            isAuthorised: () => true,
            path: "/unauthorised",
            component: Unauthorised,
        },
        {
            isPublic: true,
            isAuthorised: () => true,
            path: "/login",
            component: Login
        },
        {
            isPublic: true,
            isAuthorised: () => true,
            path: "/implicit/callback",
            component: LoginCallback,
        },
        {
            isPublic: true,
            isAuthorised: () => true,
            path: "/auth",
            component: Dashboard
        },
    ];
}
